import {pathOr} from 'ramda';

import {ApplicationStoreType} from 'reducers';
import {MARKETING_API_PROMOCODE_KEY, REFERRAL_PROMOCODE_KEY} from 'constants/product';

import {sessionStore} from 'libs/storage/storage';
import {getUrlParameter} from 'libs/url';
import {getSearchParams} from 'selectors/router/router';
import {getProductBannerState} from 'selectors/product/banner/banner';
import {getCmsBlock} from 'selectors/cmsBanner/cmsBanner';
import {getProductChildren} from 'selectors/product/product';

/**
 * Takes coupon code for discount price
 * @param {ApplicationStoreType} store - redux
 * @returns {string} - promocode
 */
export const getCoupon = (store: ApplicationStoreType): string => {
    const searchParams = getSearchParams(store);
    const coupon =
        // top priority - get coupon from url
        getUrlParameter('promo', searchParams) ||
        // saved coupon from URL promo
        sessionStore.get(REFERRAL_PROMOCODE_KEY) ||
        // try to get coupon from marketing
        sessionStore.get(MARKETING_API_PROMOCODE_KEY) ||
        // try to get coupon for package
        pathOr('', ['wizardMs', 'wizardData', 'packageCoupon'], store) ||
        // try to get coupon from top banner (top, bottom reminder)
        pathOr('', ['productBanner', 'coupon'], store) ||
        // try to get coupon from url from category
        getUrlParameter('categoryPromo', searchParams) ||
        // applied coupons when we make an query to get window product with promo get param
        pathOr('', ['product', 'appliedCoupons'], store);

    return coupon;
};

/**
 * isCouponForWizardSourcesReady selector which returns
 * is coupon sources ready for wizard request
 * @param {ApplicationStoreType} store store
 * @returns {boolean} flag
 */
export const isCouponForWizardSourcesReady = (store: ApplicationStoreType) => {
    // isBannerLoaded + isCmsBlockLoaded + isProductLoaded
    return (
        getProductBannerState(store) !== 'pending' &&
        getCmsBlock(store).status !== 'pending' &&
        Boolean(getProductChildren(store))
    );
};

/**
 * Getting MULTILENS coupon from package reminder (it is not applied coupon)
 * @param {ApplicationStoreType} store store
 * @returns {object} coupon
 */
export const getMultiLensCoupon = (store: ApplicationStoreType) => {
    return store.wizardMs?.wizardData?.availablePackageCoupon;
};
